<div class="lead-page">
  <div class="lead-shell sales-dashboard-shell">
    <div class="sales-dashboard-header">
      <div class="sales-dashboard-title">
        <h2>Sales Manager Dashboard</h2>
        <p>Track leads, follow-ups, demos, and ANPR sales activity</p>
      </div>
      <div class="sales-dashboard-actions">
        <button class="sales-dashboard-action-button" type="button" (click)="goTo('lead-management/leads')">View Leads</button>
      </div>
    </div>

    <div class="lead-loading" *ngIf="loading">Loading dashboard...</div>
    <div class="sales-dashboard-empty" *ngIf="!loading && error">Unable to load dashboard data.</div>

    <ng-container *ngIf="!loading && !error">
      <section class="sales-dashboard-section">
        <div class="sales-summary-grid">
          <div
            *ngFor="let card of cards"
            class="sales-metric-card"
            [class.sales-metric-card-clickable]="isCardClickable(card)"
            (click)="card.clickable ? openCard(card.key) : null">
            <div class="sales-metric-icon">
              <i class="bi" [ngClass]="card.icon"></i>
            </div>
            <div class="sales-metric-copy">
              <span class="sales-metric-label">{{ card.label }}</span>
              <strong class="sales-metric-value">{{ summaryCardValueMap[card.key] || 0 }}</strong>
              <p class="sales-metric-helper">{{ card.helper }}</p>
            </div>
          </div>
        </div>
      </section>

      <section class="sales-dashboard-section">
        <div class="sales-dashboard-chart-grid">
          <div class="sales-dashboard-chart-card">
            <div class="sales-dashboard-card-head">
              <h3>Lead Funnel</h3>
              <p>Progress across the sales cycle</p>
            </div>
            <div class="sales-chart-wrap">
              <canvas
                baseChart
                [data]="funnelChartData"
                [options]="funnelChartOptions"
                [type]="horizontalBarType">
              </canvas>
            </div>
          </div>

          <div class="sales-dashboard-chart-card">
            <div class="sales-dashboard-card-head">
              <h3>Lead Source Performance</h3>
              <p>Lead volume vs converted leads by source</p>
            </div>
            <div class="sales-chart-wrap" *ngIf="hasLeadSourceData; else leadSourceEmpty">
              <canvas
                baseChart
                [data]="leadSourceChartData"
                [options]="chartOptions"
                [type]="barType">
              </canvas>
            </div>
            <ng-template #leadSourceEmpty>
              <div class="sales-dashboard-empty chart-empty">No lead source data available.</div>
            </ng-template>
          </div>
        </div>
      </section>

      <section class="sales-dashboard-section">
        <div class="sales-dashboard-card-head">
          <h3>Attention</h3>
          <p>Items that need action from the sales team</p>
        </div>
        <div class="sales-attention-grid">
          <div
            *ngFor="let card of attentionCards"
            class="sales-attention-card"
            (click)="openAttention(card)">
            <div class="sales-attention-icon">
              <i class="bi" [ngClass]="card.icon"></i>
            </div>
            <span class="sales-metric-label">{{ card.label }}</span>
            <strong class="sales-metric-value">{{ attention[card.key] || 0 }}</strong>
            <p class="sales-metric-helper">{{ card.helper }}</p>
          </div>
        </div>
      </section>

      <section class="sales-dashboard-section">
        <div class="sales-dashboard-card-head">
          <h3>Sales & Installation Partners</h3>
          <p>Partner-sourced leads and installation visibility</p>
        </div>
        <div class="sales-operations-grid">
          <div *ngFor="let card of partnerCards" class="sales-operations-card" (click)="openPartnerCard(card)">
            <div class="sales-operations-icon">
              <i class="bi" [ngClass]="card.icon"></i>
            </div>
            <span class="sales-metric-label">{{ card.label }}</span>
            <strong class="sales-metric-value">{{ partnerMetrics[card.key] || 0 }}</strong>
            <p class="sales-metric-helper">{{ card.helper }}</p>
          </div>
        </div>
      </section>

      <section class="sales-dashboard-section">
        <div class="sales-dashboard-card-head">
          <h3>Operations Snapshot</h3>
          <p>Supporting operational metrics for sales context</p>
        </div>
        <div class="sales-operations-grid">
          <div *ngFor="let card of operationsCards" class="sales-operations-card">
            <div class="sales-operations-icon">
              <i class="bi" [ngClass]="card.icon"></i>
            </div>
            <span class="sales-metric-label">{{ card.label }}</span>
            <strong class="sales-metric-value">{{ operations[card.key] || 0 }}</strong>
            <p class="sales-metric-helper">{{ card.helper }}</p>
          </div>
        </div>
      </section>
    </ng-container>
  </div>
</div>
